module.exports = __webpack_public_path__ + "img/search-empty-bg.f4f6bbff.png";